<div class="advertisementView verticalCenterView">
    <div class="adsContainer" *ngIf="(!isPremium || !service.enableSubscription)">
        <app-banner-zone-map [zoneType]="['Mobile-Ads', 'Mobile-Ads-2']" [isMobile]="true"></app-banner-zone-map>
    </div>

    <div class="advertisementView__image" *ngIf="galleryImages.length">
        <ngx-image-swiper [config]="swiperConfig" [images]="galleryImages"></ngx-image-swiper>
    </div>
    <div class="advertisementView__details">
        <span class="advertisementView__city" *ngIf="Location">{{ Location }}</span>
        <span class="advertisementView__date">{{ dateStart }}</span>
    </div>
    <h1 class="advertisementView__title">{{resolveAdvTitle(advParam)}}</h1>
    <div class="advertisementView__underTitleBox">
        <span class="advertisementView__userNick">{{ advParam?.userNick || "" }}</span>
        <span class="advertisementView__age">{{ advParam?.age ? "Age:" + advParam?.age : "" }}</span>
    </div>
    <div class="advertisementView__desc">{{ advParam?.content || "" }}</div>
    <a mat-button class="advertisementView__btEdit" (click)="editAdv(advParam?.advertisementId)" *ngIf="watchingByAuthor || isUserAdmin">
        <mat-icon aria-hidden="false" aria-label="search button">edit</mat-icon>
    </a>

    <div #btWrite mat-button class="advertisementView__btWrite" [ngClass]="{'isUserAdmin': isUserAdmin}" (click)="showTextInputBar(advParam?.advertisementId)" *ngIf="!watchingByAuthor && !(advParam.isDemo && isUserAdmin) && existedConversationId < 1">
        <mat-icon aria-hidden="false" aria-label="search button">speaker_notes</mat-icon>
    </div>

    <div mat-button class="advertisementView__btExistConversations" [ngClass]="{'isUserAdmin': isUserAdmin}" *ngIf="existedConversationId > 0">
        <a [routerLink]="['/conversations', existedConversationId]" mat-flat-button color="primary">Go to conversation</a>
    </div>

    <vng-chat #textInputBar class="advertisementView__chatComponent w-100" newConversationAdvId="188" [acceptTermsEnable]="true" (submitClick)="sendInitialConversationMessage($event)" [ngClass]="{'isHidden': !textInputBarActive}" *ngIf="!watchingByAuthor"></vng-chat>
</div>
